module.exports = __webpack_public_path__ + "img/noh.facefb6a.webp";